import theme from '../styled/theme'
import { capitalize } from './stringsUtils'

export const getAppointmentHistoryStatus = estado => {
	if (estado && estado.startsWith('CANCELADO')) {
		return { label: 'Cancelado', color: theme.colors.feedback.error, showIcon: false }
	}
	switch (estado) {
		case 'PRESENTE':
			return null
		case 'AUSENTE':
			return { label: 'Ausente', color: theme.colors.feedback.error, showIcon: true }
		default:
			return { label: capitalize(estado, true), color: theme.colors.greys.disabledGrey, showIcon: false }
	}
}
